<template>
  <div class="dyk-page">
    <header class="dyk-hero">
      <span class="dyk-icon">💡</span>
      <h1>دانستنی‌های فوتبالی</h1>
      <p class="dyk-sub">
        فکت‌های راستی‌آزمایی‌شدهٔ دنیای فوتبال؛ رکوردهای عجیب و روایت‌های کمترشنیده.
        هر مطلب پیش از انتشار با منبع اصلی یا منبع آماری معتبر چک می‌شود و
        لینک منبعش پایین همین صفحه می‌آید.
      </p>
      <div class="dyk-meta">
        <span class="meta-pill">۵ فکت منتشرشده</span>
        <span class="meta-pill">✓ همه راستی‌آزمایی‌شده</span>
        <span class="meta-pill">منبع لینک‌دار در پایان صفحه</span>
      </div>
    </header>

    <div class="dyk-list">
      <article
          v-for="(f, i) in facts"
          :key="f.slug"
          :id="'fact-' + (i + 1)"
          class="fact-card"
      >
        <div class="fact-head">
          <span class="fact-no">{{ faNo(i + 1) }}</span>
          <span class="fact-cat">{{ f.category }}</span>
          <span class="fact-verified">✓ راستی‌آزمایی‌شده</span>
        </div>

        <div class="fact-body-row">
          <div class="fact-text">
            <h2>{{ f.title }}</h2>
            <p
                v-for="(p, j) in f.paragraphs"
                :key="j"
            >{{ p }}</p>
          </div>
          <div
              class="fact-figure"
              aria-hidden="true"
          >
            <span class="figure-num">{{ f.keyFigure }}</span>
            <span class="figure-label">{{ f.figureLabel }}</span>
          </div>
        </div>

        <div class="fact-tags">
          <span
              v-for="t in f.tags"
              :key="t"
              class="tag"
          >{{ t }}</span>
        </div>

        <details class="fact-verify">
          <summary>یادداشت راستی‌آزمایی</summary>
          <p>{{ f.verifyNote }}</p>
        </details>
      </article>
    </div>

    <section class="dyk-sources">
      <h2>منابع و مراجع</h2>
      <p class="sources-hint">لینک منبع هر مطلب، به ترتیب انتشار در صفحه:</p>
      <ol>
        <li
            v-for="(f, i) in facts"
            :key="f.slug"
        >
          <span class="src-title">{{ faNo(i + 1) }}. {{ f.title }}</span>
          <span class="src-sep">—</span>
          <a
              class="src-link"
              :href="f.source.url"
              target="_blank"
              rel="noopener"
          >{{ f.source.name }} ↗</a>
        </li>
      </ol>
    </section>

    <div class="dyk-links">
      <h2>تا بستهٔ بعدی سر بزنید به:</h2>
      <router-link
          to="/news"
          class="dyk-link"
      >📰 آخرین اخبار فوتبال</router-link>
      <router-link
          to="/compare"
          class="dyk-link"
      >⚖️ مقایسه دو تیم</router-link>
      <router-link
          to="/Matches"
          class="dyk-link"
      >⚽ برنامه و نتایج مسابقات</router-link>
    </div>
  </div>
</template>

<script>
import { setSeo } from '@/utils/seo'
import { footballFacts } from '@/data/footballFacts'

export default {
  name: 'DidYouKnow',

  data() {
    return {
      facts: footballFacts,
    }
  },

  created() {
    // محتوای واقعی منتشر شد → صفحه ایندکس‌پذیر است (noindex حذف شد)
    setSeo({
      title: 'دانستنی‌های فوتبالی | ضربه آزاد',
      description: 'فکت‌های راستی‌آزمایی‌شدهٔ فوتبال — رکوردهای عجیب جام جهانی، پریمیرلیگ و تاریخ فوتبال با ذکر منبع اصلی؛ بخش دانستنی‌های ضربه آزاد',
      path: '/did-you-know',
    })
  },

  methods: {
    // تبدیل عدد به رقم فارسی با صفر پیش‌رو (۰۱ تا ۰۵)
    faNo(n) {
      return String(n)
          .replace(/\d/g, (d) => '۰۱۲۳۴۵۶۷۸۹'[d])
          .padStart(2, '۰')
    },
  },
}
</script>

<style scoped lang="scss">
@import '@/assets/sass/variables';
@import '@/assets/sass/mixin';

.dyk-page {
  max-width: 760px;
  margin: 0 auto;
  padding: 24px 12px 48px;
}

// ---------- هیرو ----------
.dyk-hero {
  text-align: center;
  padding: 36px 16px 24px;

  .dyk-icon {
    font-size: 46px;
    display: inline-block;
    margin-bottom: 10px;
  }

  h1 {
    margin: 0 0 10px;
    font-size: 26px;
    color: #111827;
  }
}

.dyk-sub {
  color: #6b7280;
  font-size: 15px;
  margin: 0 auto;
  max-width: 520px;
  line-height: 1.9;
}

.dyk-meta {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
  margin-top: 16px;
}

.meta-pill {
  background: $gray-100;
  border: 1px solid $gray-200;
  color: #374151;
  font-size: 12.5px;
  font-weight: 700;
  padding: 5px 14px;
  border-radius: 999px;
}

// ---------- کارت فکت‌ها ----------
.dyk-list {
  display: flex;
  flex-direction: column;
  gap: 18px;
  margin: 18px 0;
}

.fact-card {
  background: #fff;
  border: 1px solid $gray-200;
  border-radius: 16px;
  padding: 20px 22px;
  box-shadow: $shadow-sm;
}

.fact-head {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}

.fact-no {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 34px;
  height: 34px;
  border-radius: 10px;
  background: $red;
  color: #fff;
  font-weight: 800;
  font-size: 14px;
}

.fact-cat {
  display: inline-block;
  background: linear-gradient(135deg, #047857, #10b981);
  color: #fff;
  font-weight: 700;
  font-size: 12.5px;
  padding: 5px 14px;
  border-radius: 999px;
}

.fact-verified {
  margin-right: auto;
  color: #059669;
  font-size: 12.5px;
  font-weight: 700;
}

.fact-body-row {
  display: flex;
  gap: 18px;
  align-items: flex-start;
}

.fact-text {
  flex: 1;
  min-width: 0;

  h2 {
    margin: 0 0 10px;
    font-size: 17.5px;
    line-height: 1.7;
    color: #111827;
  }

  p {
    margin: 0 0 10px;
    color: #374151;
    font-size: 14.5px;
    line-height: 2.05;
    text-align: justify;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.fact-figure {
  flex-shrink: 0;
  width: 112px;
  min-height: 96px;
  border-radius: 14px;
  background: $gray-50;
  border: 1px solid $gray-200;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 10px 6px;

  .figure-num {
    font-size: 27px;
    font-weight: 900;
    color: $red;
    line-height: 1.15;
  }

  .figure-label {
    font-size: 11.5px;
    font-weight: 700;
    color: #6b7280;
  }
}

.fact-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 14px;
}

.tag {
  background: $gray-50;
  border: 1px solid $gray-200;
  color: #6b7280;
  font-size: 11.5px;
  font-weight: 600;
  padding: 3px 11px;
  border-radius: 999px;
}

.fact-verify {
  margin-top: 14px;
  border-top: 1px dashed $gray-300;
  padding-top: 10px;

  summary {
    cursor: pointer;
    color: #1e3a8a;
    font-size: 13px;
    font-weight: 700;
    user-select: none;

    &:hover { color: #3b82f6; }
  }

  p {
    margin: 8px 0 2px;
    color: #6b7280;
    font-size: 13px;
    line-height: 1.95;
    text-align: justify;
  }
}

// ---------- منابع (پایین صفحه) ----------
.dyk-sources {
  background: #fff;
  border: 1px solid $gray-200;
  border-radius: 16px;
  padding: 20px 22px;
  margin: 8px 0 18px;
  box-shadow: $shadow-sm;

  h2 {
    margin: 0 0 6px;
    font-size: 16px;
    color: #111827;
  }
}

.sources-hint {
  margin: 0 0 12px;
  color: #9ca3af;
  font-size: 12.5px;
}

.dyk-sources ol {
  margin: 0;
  padding: 0;
  list-style: none;
  counter-reset: src;

  li {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 6px;
    padding: 9px 0;
    border-bottom: 1px dashed $gray-200;

    &:last-child { border-bottom: none; }
  }
}

.src-title {
  color: #374151;
  font-size: 13.5px;
  font-weight: 700;
}

.src-sep { color: $gray-300; }

.src-link {
  color: #3b82f6;
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
  word-break: break-word;

  &:hover {
    text-decoration: underline;
    color: #1e3a8a;
  }
}

// ---------- لینک‌های سرگردانی ----------
.dyk-links {
  background: #fff;
  border-radius: 16px;
  padding: 18px;
  box-shadow: $shadow-sm;

  h2 {
    margin: 0 0 12px;
    font-size: 15px;
    color: #111827;
  }
}

.dyk-link {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border-radius: 12px;
  color: #1e3a8a;
  font-weight: 700;
  font-size: 14px;
  text-decoration: none;
  transition: background .15s;

  &:hover { background: $gray-50; }
}

// ---------- رسپانسیو ----------
@media (max-width: 768px) {
  .dyk-page {
    padding: 12px 8px 36px;
  }

  .dyk-hero {
    padding: 22px 6px 16px;

    h1 { font-size: 22px; }
  }

  .dyk-sub { font-size: 13.5px; }

  .fact-card {
    padding: 16px 14px;
    border-radius: 14px;
  }

  .fact-body-row {
    flex-direction: column-reverse;
    gap: 12px;
  }

  .fact-figure {
    width: 100%;
    min-height: 0;
    flex-direction: row;
    gap: 8px;
    padding: 8px 12px;

    .figure-num { font-size: 22px; }
  }

  .fact-text {
    h2 { font-size: 15.5px; }

    p { font-size: 13.5px; }
  }

  .fact-verified {
    margin-right: 0;
  }

  .dyk-sources {
    padding: 16px 14px;
  }

  .src-title { font-size: 12.5px; }
  .src-link { font-size: 12.5px; }
}
</style>
